"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadService = void 0;
var api_wrapper_1 = require("../api/api-wrapper");
var manychat_api_1 = require("../api/manychat.api");
var aov_helper_const_1 = require("../const/aov-helper.const");
var helper_const_1 = require("../const/helper.const");
var infrastructure_const_1 = require("../const/infrastructure.const");
var input_output_helper_const_1 = require("../const/input-output-helper.const");
var input_mapping_const_1 = require("../const/input.mapping.const");
var leads_const_1 = require("../const/leads.const");
var mappings_const_1 = require("../modules/fitfms/lead-form/mappings.const");
var object_service_1 = require("./object-service");
var settings_service_1 = require("./settings.service");
var backend_services_1 = require("./backend-services");
var LeadService = /** @class */ (function () {
    function LeadService() {
        this.apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
        this.manyChatApi = object_service_1.ObjectService.getInstance(manychat_api_1.ManyChatApi);
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
    }
    LeadService.prototype.getLeadFromLocalStorage = function () {
        var _a;
        if (localStorage.getItem('leadhash')) {
            var lead_1 = {};
            for (var key in mappings_const_1._LeadFormMappings) {
                var value = localStorage.getItem(mappings_const_1._LeadFormMappings[key].localStorageKey);
                if (value) {
                    lead_1[key] = value;
                }
            }
            leads_const_1._UtmFields.forEach(function (utm) {
                if (localStorage.getItem(utm)) {
                    lead_1[utm] = localStorage.getItem(utm);
                }
                if (localStorage.getItem(utm + '_last')) {
                    lead_1[utm + '_last'] = localStorage.getItem(utm + '_last');
                }
            });
            if (localStorage.getItem(leads_const_1._FirstVisit)) {
                lead_1.firstVisit = new Date(localStorage.getItem(leads_const_1._FirstVisit));
            }
            if (localStorage.getItem('leadhash')) {
                lead_1.leadhash = localStorage.getItem('leadhash');
            }
            if ((0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId)) {
                lead_1.studioId = +(0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
            }
            lead_1.paymentTechnology = (_a = localStorage.getItem('paymentTechnology')) !== null && _a !== void 0 ? _a : undefined;
            if ((0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId)) {
                lead_1.studioId = +(0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
            }
            if (!(lead_1 === null || lead_1 === void 0 ? void 0 : lead_1.tenant)) {
                lead_1.tenant = this.config.get.tenantKey;
            }
            return lead_1;
        }
        return undefined;
    };
    /**
     * Create an entry in our firestore lead collection
     * @param leadhash
     * @param lead
     */
    LeadService.prototype.createFirestoreLead = function (leadhash, lead) {
        return __awaiter(this, void 0, void 0, function () {
            var firstVisit, utmFields_1, aov, membership, membershipName, funnelConfigId, startDate, preuseDate, taxId, dateOfBirth, street, houseNumber, zip, city, countryCode, tech, provider, fittecLeadCreation, e_1;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
            return __generator(this, function (_8) {
                switch (_8.label) {
                    case 0:
                        _8.trys.push([0, 2, , 3]);
                        if (lead.gender === 'undefined')
                            lead.gender = undefined;
                        console.log('Creating lead', lead);
                        firstVisit = (_a = localStorage.getItem(leads_const_1._FirstVisit)) !== null && _a !== void 0 ? _a : undefined;
                        utmFields_1 = {};
                        leads_const_1._UtmFields.forEach(function (a) {
                            var _a;
                            if (localStorage.getItem(a)) {
                                utmFields_1[a] = (_a = localStorage.getItem(a)) !== null && _a !== void 0 ? _a : undefined;
                            }
                        });
                        aov = (0, aov_helper_const_1._ParseAOV)((_b = localStorage.getItem(input_mapping_const_1._AllMappings.rateBundleAOV.uid)) !== null && _b !== void 0 ? _b : localStorage.getItem('aov'));
                        membership = (_d = (_c = localStorage.getItem(input_mapping_const_1._AllMappings.rateBundleTermId.uid)) !== null && _c !== void 0 ? _c : localStorage.getItem('Memberships')) !== null && _d !== void 0 ? _d : undefined;
                        membershipName = (_e = localStorage.getItem('membershipName')) !== null && _e !== void 0 ? _e : undefined;
                        funnelConfigId = this.config.get.funnelConfigId;
                        startDate = (_f = localStorage.getItem(input_mapping_const_1._AllMappings.rateBundleStartDate.uid)) !== null && _f !== void 0 ? _f : undefined;
                        preuseDate = (_g = localStorage.getItem(input_mapping_const_1._AllMappings.preuseDate.uid)) !== null && _g !== void 0 ? _g : undefined;
                        taxId = localStorage.getItem(input_mapping_const_1._AllMappings.taxId.uid);
                        dateOfBirth = (_h = localStorage.getItem(input_mapping_const_1._BirthdayForm.dateOfBirth.uid)) !== null && _h !== void 0 ? _h : undefined;
                        street = (_j = localStorage.getItem(input_mapping_const_1._AllMappings.street.uid)) !== null && _j !== void 0 ? _j : undefined;
                        houseNumber = (_k = localStorage.getItem(input_mapping_const_1._AllMappings.houseNumber.uid)) !== null && _k !== void 0 ? _k : undefined;
                        zip = (_l = localStorage.getItem(input_mapping_const_1._AllMappings.zipCode.uid)) !== null && _l !== void 0 ? _l : undefined;
                        city = (_m = localStorage.getItem(input_mapping_const_1._AllMappings.city.uid)) !== null && _m !== void 0 ? _m : undefined;
                        countryCode = (_o = localStorage.getItem(input_mapping_const_1._AllMappings.countryCode.uid)) !== null && _o !== void 0 ? _o : undefined;
                        tech = (_q = (_p = this.config.get) === null || _p === void 0 ? void 0 : _p.technologyType) !== null && _q !== void 0 ? _q : 'magicline';
                        provider = tech === 'magicline'
                            ? {
                                name: 'magicline',
                                studioId: (_r = localStorage.getItem(input_mapping_const_1._AllMappings.studioId.uid)) !== null && _r !== void 0 ? _r : '',
                                forceOpenAPI: (_u = (_t = (_s = this.config) === null || _s === void 0 ? void 0 : _s.get) === null || _t === void 0 ? void 0 : _t.forceOpenAPI) !== null && _u !== void 0 ? _u : false,
                            }
                            : undefined;
                        fittecLeadCreation = __assign(__assign(__assign(__assign(__assign({ tenant: this.config.get.tenantKey, fittecId: this.config.get.fittecId, email: lead.email, givenName: lead.firstname, familyName: lead.lastname, createdTime: new Date().getTime(), gender: (_v = lead.gender) !== null && _v !== void 0 ? _v : undefined, leadStatus: 'open', originUrl: window.location.href, phone: lead.phone, studioId: (_w = localStorage.getItem(input_mapping_const_1._AllMappings.studioId.uid)) !== null && _w !== void 0 ? _w : undefined, checkbox: 'true', member: false, firstVisit: firstVisit ? new Date(firstVisit).getTime() : undefined, membership: membership, membershipName: membershipName, aov: aov, clv: (aov === null || aov === void 0 ? void 0 : aov.total) ? (0, helper_const_1._RoundUpToTwoDecimals)(aov.total * ((_x = this.config.get.averageCustomerDuration) !== null && _x !== void 0 ? _x : 1.5)) : undefined, leadhash: leadhash, version: '2.3', termDuration: (_y = localStorage.getItem('termDuration')) !== null && _y !== void 0 ? _y : undefined, studioName: (_1 = (_z = localStorage.getItem('StudioName')) !== null && _z !== void 0 ? _z : (_0 = this.config.get) === null || _0 === void 0 ? void 0 : _0.studioName) !== null && _1 !== void 0 ? _1 : undefined, consents: lead.privacyConfiguration, newsletterOptIn: lead.newsletterOptIn, funnelConfigId: funnelConfigId, provider: provider }, (taxId && (taxId === null || taxId === void 0 ? void 0 : taxId.length) ? { taxId: taxId } : {})), (((_4 = (_3 = (_2 = this.config) === null || _2 === void 0 ? void 0 : _2.get) === null || _3 === void 0 ? void 0 : _3.leadForm) === null || _4 === void 0 ? void 0 : _4.waitForCreationResult) === true ? { waitForResult: true } : {})), (startDate ? { startDate: startDate } : {})), (preuseDate ? { preuseDate: preuseDate } : {})), { dateOfBirth: dateOfBirth ? dateOfBirth : undefined, street: street ? street : undefined, houseNumber: houseNumber ? houseNumber : undefined, city: city ? city : undefined, zip: zip ? zip : undefined, countryCode: countryCode ? countryCode : undefined, utm_campaign: utmFields_1.utm_campaign, utm_content: utmFields_1.utm_content, utm_medium: utmFields_1.utm_medium, utm_source: utmFields_1.utm_source });
                        return [4 /*yield*/, this.sendFirestoreLead(fittecLeadCreation)];
                    case 1:
                        _8.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _8.sent();
                        console.error('LEAD CREATION ERROR', e_1);
                        if (((_7 = (_6 = (_5 = this.config) === null || _5 === void 0 ? void 0 : _5.get) === null || _6 === void 0 ? void 0 : _6.leadForm) === null || _7 === void 0 ? void 0 : _7.waitForCreationResult) === true)
                            throw e_1;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LeadService.prototype.createTechnologyTypeLead = function (lead) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.apiWrapper.createLead(lead)];
                    case 1:
                        response = _a.sent();
                        if (response === null || response === void 0 ? void 0 : response.uuid) {
                            localStorage.setItem('leaduuid', String(response.uuid));
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        console.error('SEVER ERROR HAPPENED', e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     *  Create a lead in manychat
     * @param lead
     */
    LeadService.prototype.createManychatLead = function (lead) {
        return __awaiter(this, void 0, void 0, function () {
            var manyChatObject, leadResponse, _a;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        manyChatObject = {
                            consent_phrase: 'Consent',
                            has_opt_in_email: true,
                            has_opt_in_sms: true,
                            gender: 'unknown',
                            first_name: lead.firstname,
                            last_name: lead.lastname,
                            whatsapp_phone: lead.phone,
                            name: lead.firstname + ' ' + lead.lastname,
                            tenantId: this.config.get.tenantKey,
                            studioId: lead.studioId,
                            manychatTenant: ((_c = (_b = this.config.get) === null || _b === void 0 ? void 0 : _b.leadForm) === null || _c === void 0 ? void 0 : _c.manychatTenant) || this.config.get.tenantKey,
                        };
                        return [4 /*yield*/, this.manyChatApi.createLeadInManyChat(manyChatObject)];
                    case 1:
                        leadResponse = _d.sent();
                        if ((leadResponse === null || leadResponse === void 0 ? void 0 : leadResponse.success) && (leadResponse === null || leadResponse === void 0 ? void 0 : leadResponse.id)) {
                            localStorage.setItem('manychat-lead-id', leadResponse.id);
                        }
                        else if (leadResponse.error && this.config.get.environment === 'dev') {
                            //TODO: fix
                            // _ShowErrorMessage(leadResponse.error);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _d.sent();
                        console.error('Is manychat / strato down??');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LeadService.prototype.sendFirestoreLead = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var leadUrl;
            var _this = this;
            return __generator(this, function (_a) {
                leadUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', this.config.get.environment);
                return [2 /*return*/, (0, backend_services_1.betterFetch)(leadUrl + '/lead/create', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(body),
                    })
                        .then(function (createResponse) {
                        if (!createResponse.ok) {
                            return Promise.reject(createResponse.json());
                        }
                        return createResponse.json();
                    })
                        .then(function (created) {
                        return created;
                    })
                        .catch(function (createdErr) { return __awaiter(_this, void 0, void 0, function () {
                        var error;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, createdErr];
                                case 1:
                                    error = _a.sent();
                                    throw error;
                            }
                        });
                    }); })];
            });
        });
    };
    LeadService.prototype.finishLead = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lead, leadUrl;
            return __generator(this, function (_a) {
                lead = this.getLeadFromLocalStorage();
                lead.lastVisit = new Date();
                if (lead.firstVisit && lead.lastVisit) {
                    lead.daysFromLeadToMember = (0, helper_const_1._DiffTimes)(lead.firstVisit, lead.lastVisit).days;
                }
                leadUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', this.config.get.environment);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Create fitaso lead, read studio id directly from localstorage to support string studioIds
     * @param lead
     * @param config
     * @returns
     */
    LeadService.prototype.createFitasoLead = function (lead, config) {
        return __awaiter(this, void 0, void 0, function () {
            var leadUrl, leadStudioId, fitasoStudioId;
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                try {
                    leadUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', this.config.get.environment);
                    leadStudioId = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
                    fitasoStudioId = (_b = (_a = config.get) === null || _a === void 0 ? void 0 : _a.leadForm) === null || _b === void 0 ? void 0 : _b.fitasoStudioMapping[leadStudioId];
                    if (!fitasoStudioId) {
                        console.error('Fitaso is enabled but no fitaso studio mapping found for studio id', leadStudioId);
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, (0, backend_services_1.betterFetch)(leadUrl + '/lead/create-fitaso-lead', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(__assign(__assign({}, lead), { studioId: fitasoStudioId })),
                        })
                            .then(function (created) {
                            return created;
                        })
                            .catch(function (createdErr) { return __awaiter(_this, void 0, void 0, function () {
                            var error;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, createdErr];
                                    case 1:
                                        error = _a.sent();
                                        throw error;
                                }
                            });
                        }); })];
                }
                catch (e) {
                    console.error('failed to create fitaso lead', e);
                }
                return [2 /*return*/];
            });
        });
    };
    LeadService.prototype.hardNewLeadUUID = function () {
        var uuid = crypto.randomUUID();
        localStorage.setItem('required-uuid', uuid);
        return uuid;
    };
    LeadService.prototype.createLead = function () {
        var _a;
        // query param overwrites uuid, comes from fitcrm links to ensure proper lead matching
        var url = new URL(window.location.href);
        var urlUuid = (_a = url.searchParams.get('setuuid')) !== null && _a !== void 0 ? _a : url.searchParams.get('fittecUUID');
        if (urlUuid) {
            localStorage.setItem('required-uuid', urlUuid);
            localStorage.setItem('utm_campaign', 'automations');
            localStorage.setItem('utm_source', 'fittec');
            localStorage.setItem('utm_medium', 'automations');
            url.searchParams.delete('setuuid');
            url.searchParams.delete('fittecUUID');
            window.history.replaceState({}, document.title, url.toString());
            return urlUuid;
        }
        if (this.getLead()) {
            return this.getLead();
        }
        return this.hardNewLeadUUID();
    };
    LeadService.prototype.getLead = function () {
        return localStorage.getItem('required-uuid') || undefined;
    };
    return LeadService;
}());
exports.LeadService = LeadService;
